<template>
  <div class="top-toolbar is-flex no-print">
    <div class="top-tool" v-for="tool in tools" :key="tool[0]" :class="tool[0]" :data-balloon="capitalize(tool[1])" data-balloon-pos="down" @click="callback(tool[0])">
      <span :aria-label="tool[0]"><i class="fal" :class="'fa-'+tool[0]" aria-hidden="true"></i></span>
    </div>
  </div>
</template>
<script>
import i18n from '@/i18n'
const tools = [['undo', i18n.t('magicboard.undo')], ['redo', i18n.t('magicboard.redo')], ['copy', i18n.t('magicboard.copy')], ['paste', i18n.t('magicboard.paste')]]

export default {
  props: ['callback'],
  data: function () {
    return {
      tools
    }
  },
  methods: {
    capitalize: function (s) {
      return s.charAt(0).toUpperCase() + s.slice(1)
    }
  }
}

</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

.top-toolbar {
  justify-content: center;
  align-items: center;
  position: absolute;
  height: 2rem;
  top: 0.5rem;
  left: 10vw;

  @include touch {
    left: 15vw;
  }

  .top-tool {
    color: $white;
    font-size: 0.9rem;
    margin: 0 0.5rem;
    &:hover,
    &:focus {
      color: $primary;
    }
  }
}
</style>
